export const buildOauthQuery = (cfg: any = {}, opts: any = {}) => {
  const query = [];
  query.push(`client_id=${encodeURIComponent(cfg.client_id)}`);
  query.push(`redirect_uri=${encodeURIComponent(cfg.redirect_uri)}`);
  query.push(`response_type=${encodeURIComponent(cfg.response_type)}`);

  if (cfg.organization_id && opts.organization_id == null) {
    query.push(`organization_id=${encodeURIComponent(cfg.organization_id)}`);
  }

  if (cfg.flow) {
    query.push(`flow=${encodeURIComponent(cfg.flow)}`);
  }

  if (cfg.state) {
    query.push(`state=${encodeURIComponent(cfg.state)}`);
  }

  if (cfg.code_challenge) {
    query.push(`code_challenge=${encodeURIComponent(cfg.code_challenge)}`);
  }

  if (cfg.code_challenge_method) {
    query.push(`code_challenge_method=${encodeURIComponent(cfg.code_challenge_method)}`);
  }

  if (cfg.prompt) {
    query.push(`prompt=${encodeURIComponent(cfg.prompt)}`);
  }

  if (cfg.no_sign_up === '1') {
    query.push(`no_sign_up=${encodeURIComponent(cfg.no_sign_up)}`);
  }

  if (cfg.new_signin === '1') {
    query.push(`new_signin=${encodeURIComponent(cfg.new_signin)}`);
  }

  Object.keys(opts).forEach((key) => {
    if (opts[key]) {
      query.push(`${key}=${encodeURIComponent(opts[key])}`);
    }
  });

  return query.join('&');
};
